import * as React from "react";
import { connect } from "react-redux";
import { ApplicationState } from "../../../store";
import { actionCreators } from "../../../store/integration/MondayComStore";
import { SourceType } from "../../../store/ExternalEpmConnectStore";
import { IConnectionsState } from "../../../store/integration/common";
import MondayComConnectionEdit from "../../integration/MondayCom/MondayComConnectionEdit";
import BasicAuthConnectionCard from './BasicAuthConnectionCard';

type OwnProps = {}
type StateProps = { connections: IConnectionsState };
type Props = StateProps & OwnProps & typeof actionCreators;
const MondayComConnectionCard = (props: Props) => <BasicAuthConnectionCard
    system={SourceType.MondayCom}
    connections={props.connections.data}
    renderConnect={(onCreated, onDismiss) => <MondayComConnectionEdit
        onCreated={(connectionId: string) => {
            props.loadConnections();
            onCreated(connectionId);
        }}
        onDismiss={onDismiss}
    />}
/>;
function mapStateToProps(state: ApplicationState, ownProps?: OwnProps): StateProps {
    return { connections: state.mondayCom.connections }
}
export default connect(mapStateToProps, actionCreators)(MondayComConnectionCard);